import {
  Box,
  Button,
  createStyles,
  Flex,
  getStylesRef,
  Menu,
  Text,
} from "@mantine/core";

import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AddButton from "../../../components/AddButton";
import { IconSettingsPlus } from "@tabler/icons-react";
import TaskTable from "../../../components/TaskTable";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import AddTaskModal from "../../../components/TaskTable/AddTaskModal";
import { getAllTasks, getTasks, getTaskTypes } from "../../../services/task";
import { TrackPageView } from "../../../config/mixpanelConfig";
import AddTaskReport from "./AddTaskReport";
import { getAllPatientsModal } from "../../../services/patient";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { getAllSignatures } from "../../../services/signature";
import { IoIosArrowDown } from "react-icons/io";
// import TaskReportDrawer from "../../../components/TaskReportDrawer";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Form8615ReportPdf } from "../../../components/Form8615Pdf";
import TaskReportDrawer from "../../../components/TaskReportDrawer";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
  },
  btn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    gap: 10,
    // marginLeft: "auto",
    marginTop: 50,
  },
  mymodal: {
    width: 818,
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },
  tableWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100vh",
  },
  pagination: {
    margin: "1rem 0",
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
  },
  btnIcon: {
    ref: getStylesRef("btnIcon"),
    background: "#FFBA45",
    borderRadius: 5,
    cursor: "pointer",
  },
  createMenuBtn: {
    padding: 12,
    cursor: "pointer",
    borderRadius: "8px",
    border: "1px solid #FFAF4A",
    backgroundColor: "#FFAF4A",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    height: 48,
    "& .arrowBox": {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      width: 30,
      borderLeft: "2px solid #1D2939",
    },
  },

  menuDropdown: {
    padding: 8,
    borderRadius: 4,
    backgroundColor: "#FFF",
    boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.10)",
  },
  menuDropdownItem: {
    padding: "4px 12px",
    ":hover": {
      backgroundColor: "#F4F4F5",
      borderRadius: 4,
    },
  },
}));
const AllTasks = () => {
  const { tasksCount } = useSelector((state) => state?.task);
  const [currentPage, setCurrentPage] = useState(1);
  const { profile } = useSelector((state) => state.profile);
  const [
    TaskReportDrawerOpened,
    { open: TaskReportDrawerOpen, close: TaskReportDrawerClose },
  ] = useDisclosure(false);

  useEffect(() => {
    getTasks(currentPage, "all");
  }, [currentPage]);

  // useEffect(() => {
  //   getAllTasks("all");
  // }, []);

  useEffect(() => {
    TrackPageView("Task");
  }, []);

  useEffect(() => {
    getAllPatientsModal();
    getAllSignatures();
    getTaskTypes("all");
  }, []);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const navigate = useNavigate();
  const { classes } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);
  const [openedReport, { open: reportOpenModal, close: reportCloseModal }] =
    useDisclosure(false);
  const [reportType, setReportType] = useState(null);

  const openReportDrawer = (type) => {
    setReportType(type);
    TaskReportDrawerOpen();
  };

  return (
    <Box className={classes.content}>
      <AppNavbar title="Task" profile={profile} />
      <AddTaskModal
        opened={opened}
        onclose={(nType) => {
          close();
        }}
        title={"Add a New Task"}
      />
      <Box px={20}>
        <Box className={classes.btn}>
          {/* <Button color="yellow" c={"#000"} onClick={reportOpenModal}>
            Create Report
          </Button> */}
          <AddButton title={"Add New Task"} onClick={open} />
          <Menu
            classNames={{
              dropdown: classes.menuDropdown,
              item: classes.menuDropdownItem,
            }}
          >
            <Menu.Target>
              <Flex gap={12} className={classes.createMenuBtn}>
                <Text ff="Inter" fz={16} fw={600} color="#171717">
                  Create Report
                </Text>
                <Box className="arrowBox">
                  <IoIosArrowDown size={24} color="#000000" />
                </Box>
              </Flex>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item
                fz={14}
                fw={600}
                ff="Inter"
                color="#262626"
                onClick={() => openReportDrawer("task")}
              >
                Task Report
              </Menu.Item>
              <Menu.Item
                fz={14}
                fw={600}
                ff="Inter"
                color="#262626"
                onClick={() => openReportDrawer("form8615")}
              >
                Form 8615
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>

          {(profile?.user?.type !== "staff" ||
            (profile?.user?.type === "staff" &&
              profile?.user?.role === "admin")) && (
            <IconSettingsPlus
              color="black"
              stroke={1}
              className={classes.btnIcon}
              size={40}
              onClick={() => navigate("/home/taskType")}
            />
          )}
        </Box>
        <Box className={classes.tableWrapper}>
          <TaskTable currentPage={currentPage} />
          <CustomPagination
            data={tasksCount}
            itemsPerPage={10}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        </Box>
        {/* <AddTaskReport
          opened={openedReport}
          onclose={reportCloseModal}
          title={"Create New Report"}
        /> */}
      </Box>
      <TaskReportDrawer
        drawerOpen={TaskReportDrawerOpened}
        drawerClose={TaskReportDrawerClose}
        reportType={reportType}
      />
    </Box>
  );
};

export default AllTasks;
